import gql from "graphql-tag";

export const DELETE_REPORT_MUTUATION = gql`
  mutation DeleteReport($reportId: ID!) {
    deleteReport(reportId: $reportId)
  }
`;
